import React from "react";
import PaginationComponent from "../global/pagination";
import { Link } from "gatsby";
import TwemojiComponent from "../core/twemoji";
const moment = require(`moment`);

const NoteIndexListingComponent = ({ data, path, pageContext }) => {
    return (
        <>
            <div className="flex justify-center">
                <div className="pt-8 pb-8 sm:pt-6 sm:pb-6 max-w-none xl:w-5/6">
                    <ul>
                        {data.edges.map(({ node, index }) => {
                            return (
                                <li key={node.fields.slug} className="py-8">
                                    <article className="h-entry hentry space-y-2 xl:items-baseline ">
                                        <div className="space-y-3">
                                            <div>
                                                <dt className="sr-only">Published on</dt>
                                                <dd className="flex text-base font-medium leading-6 text-gray-500 dark:text-gray-400">
                                                    <time dateTime={moment(node.frontmatter.date).format("YYYY-MM-DDTHH:mm:ssTZD")} className="dt-published published flex items-center">
                                                        <TwemojiComponent emoji="calendar" size="" />
                                                        <span className="ml-1.5">
                                                            {moment(node.frontmatter.date).format("MMM DD, YYYY - HH:mm")}
                                                        </span>
                                                    </time>
                                                </dd>
                                            </div>
                                            <h2 className="text-3xl font-bold leading-9 tracking-tight">
                                                <Link to={node.fields.slug} className="entry-title text-gray-900 dark:text-gray-100">
                                                    {node.frontmatter.title}
                                                </Link>
                                            </h2>
                                            <div className="prose prose-lg max-w-none dark:text-gray-400 italic border-l-4 border-l-blue-500 p-5" dangerouslySetInnerHTML={{ __html: node.html }} />
                                        </div>
                                    </article>
                                </li>
                            )
                        })}
                    </ul>
                    <PaginationComponent path={path} currentPageNo={pageContext.currentPage} totalPages={pageContext.totalPages} hasPrevPage={pageContext.hasPrevPage} hasNextPage={pageContext.hasNextPage} /> 
                </div>
            </div>
        </>
    )
}

export default NoteIndexListingComponent